// extracted by mini-css-extract-plugin
module.exports = {"BuiltTough":"BuiltTough_BuiltTough__lwWZ5"};